/**
 * App-wide constants
 */

// Sandvik brand colors (mirrored from tailwind.config.js for JS usage)
export const COLORS = {
  carbonBlack: '#101010',
  electricBlue: '#1441F5',
  vibrantOrange: '#F54B00',
  gold: '#A08C64',
  goldLight: '#EBE6DC',
  blueDark: '#003C7D',
  blueLight: '#C8DCFF',
  success: '#7FCC5B',
  warning: '#FFD74B',
  error: '#EB0D0D',
};

// Chart palette
export const CHART_COLORS = ['#1441F5', '#A08C64', '#F54B00', '#7FCC5B', '#FFD74B', '#327DFF'];

// Product badge types
export const BADGES = {
  POWER_CARBIDE: { label: 'PowerCarbide', bg: '#101010', text: '#FFFFFF' },
  RECOMMENDED: { label: 'Recommended', bg: '#A08C64', text: '#101010' },
  NEW_MODEL: { label: 'New model available', bg: '#F54B00', text: '#FFFFFF' },
  OUTPHASED: { label: 'Outphased', bg: '#E6E6E6', text: '#575757' },
  GOLDEN_SHANK: { label: 'GoldenShank', bg: '#A08C64', text: '#FFFFFF' },
};

// Order statuses
export const ORDER_STATUS = {
  OPEN: 'open',
  PENDING: 'pending',
  PROCESSING: 'processing',
  SHIPPED: 'shipped',
  DELIVERED: 'delivered',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
};

// ToolFinder wizard steps
export const TOOLFINDER_STEPS = [
  { id: 1, label: 'Application' },
  { id: 2, label: 'Category' },
  { id: 3, label: 'Specifications' },
  { id: 4, label: 'Ground Conditions' },
  { id: 5, label: 'Results' },
];

// DSC component types
export const DSC_COMPONENTS = {
  DTH: ['DTH Bit', 'DTH Hammer', 'DTH Drillpipe'],
  TH: ['TH Shanks', 'TH Rods', 'TH Bits'],
  TH_WITH_COUPLING: ['TH Shanks', 'Couplings', 'TH Rods', 'TH Bits'],
};

// Rock drill manufacturers (for DSC TH configurator)
export const ROCK_DRILL_MAKES = [
  'Boart', 'Epiroc', 'Furukawa', 'Gardner-Denver',
  'Ingersoll-Rand', 'Krupp', 'Maxdrill', 'Sandvik',
];

// Max limits
export const MAX_COMPARE_ITEMS = 3;
export const MAX_FAVOURITE_LISTS = 10;
export const MAX_CART_IMPORT_ITEMS = 20;

// Breakpoints
export const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
};

// ============================================================================
// Group F — Portal & Contact
// ============================================================================

// Case statuses (CRM lifecycle)
export const CASE_STATUS = {
  NEW: 'new',
  IN_PROGRESS: 'in_progress',
  CLOSED: 'closed',
};

// Session inactivity timeouts (ms)
export const IDLE_TIMEOUT_MS = 5 * 60 * 1000;
export const IDLE_WARNING_MS = 60 * 1000;

// Invoice status (for InvoicesList tab filtering)
export const INVOICE_STATUS = {
  PAID: 'paid',
  PENDING: 'pending',
  OVERDUE: 'overdue',
};

// ============================================================================
// CMS — Asset & Content Management (Group H)
// ============================================================================

// CMS user roles (mapped in Sandvik App Admin)
export const CMS_ROLES = {
  CMS_CONTRIBUTOR: 'cms_contributor',
  CMS_ADMIN: 'cms_admin',
};

// Content lifecycle statuses
export const CMS_CONTENT_STATUS = {
  DRAFT: 'draft',
  SUBMITTED: 'submitted',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  PUBLISHED: 'published',
};

// Image view types for product image mapping
export const CMS_IMAGE_VIEW_TYPES = [
  'top',
  'iso',
  'side',
  'cutaway',
  'in-use',
  'thumbnail',
];

// Hero carousel limits
export const MAX_HERO_SLIDES = 10;
